import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
// import "react-mdl/extra/material.css";
// import "react-mdl/extra/material.js";
import "bootstrap/dist/css/bootstrap.css";
import "nepali-calander/dist/styles.css";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./assets/scss/app.scss";
import "./assets/scss/main.scss";
import * as serviceWorker from "./serviceWorker";
import store from "./store";
import history from "./utils/History";

ReactDOM.render(
  <Router history={history} basename={"/"}>
    <Provider store={store}>
      {/* <React.StrictMode> */}
      <App />
      {/* </React.StrictMode> */}
    </Provider>
  </Router>,
  document.getElementById("root")
);

serviceWorker.unregister();
